import { fieldValidationMessages } from 'app/constants';
import { PasswordPolicy } from 'types/auth';

export const passwordPolicyDefaults: PasswordPolicy = {
  maximumLength: 99,
  minimumLength: 6,
  requireUppercase: false,
  requireLowercase: false,
  requireNumbers: false,
  notSameAsCurrent: false,
  requireSpecialCharacters: false,
  pattern: '.{6}',
};

export const errorMessages = {
  errors: {
    email: {
      required: fieldValidationMessages.REQUIRED_EMAIL,
    },
    password: {
      required: fieldValidationMessages.REQUIRED_PASSWORD,
      minLength: fieldValidationMessages.MIN_PASSWORD,
      pattern: fieldValidationMessages.WEAK_PASSWORD,
    },
    passwordRepeat: {
      minLength: fieldValidationMessages.MIN_PASSWORD,
      match: fieldValidationMessages.PASSWORD_MATCH,
    },
  },
};

const pluralize = (word: string) => (word.length > 1 ? `${word}s` : `${word}`);

export const buildPasswordPolicyMessage = ({
  minimumLength,
  requireNumbers,
  requireUppercase,
  requireSpecialCharacters,
  requireLowercase,
}: PasswordPolicy) => {
  const beginning = 'Your password should be';
  const minLength = `at least ${minimumLength} ${pluralize('character')}`;
  let message = `${beginning} ${minLength}`;

  const charRequirements: string[] = [];
  if (requireLowercase) {
    charRequirements.push('1 lowercase letter');
  }

  if (requireUppercase) {
    charRequirements.push('1 uppercase letter');
  }
  if (requireNumbers) {
    charRequirements.push('1 number');
  }
  if (requireSpecialCharacters) {
    charRequirements.push('special character');
  }

  charRequirements.forEach((item, index) => {
    message = `${message}${
      index === 0
        ? ' and contain at least'
        : index === charRequirements.length - 1
        ? ' and'
        : ','
    } ${item}`;
  });

  return message;
};

export const concatFirstAndLastName = (
  firstName?: string,
  lastName?: string
): string => `${firstName || ''} ${lastName || ''}`.trim();
